import MyProfileSettings from "./MyProfileSettings";

export default MyProfileSettings;
